import script from "./UserChatList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserChatList.vue?vue&type=script&setup=true&lang=js"

import "./UserChatList.vue?vue&type=style&index=0&id=627b9be2&lang=scss"

const __exports__ = script;

export default __exports__